"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Bar = exports.Circular = exports.Linear = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _LinearProgress = _interopRequireDefault(require("@material-ui/core/LinearProgress"));

var _CircularProgress = _interopRequireDefault(require("@material-ui/core/CircularProgress"));

var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));

var _Box = _interopRequireDefault(require("@material-ui/core/Box"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _Clear = _interopRequireDefault(require("@material-ui/icons/Clear"));

var _Done = _interopRequireDefault(require("@material-ui/icons/Done"));

var css = _interopRequireWildcard(require("./Progress.styles"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Linear = function Linear(_ref) {
  var _ref$invert = _ref.invert,
      invert = _ref$invert === void 0 ? false : _ref$invert,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? 0 : _ref$value,
      props = _objectWithoutProperties(_ref, ["invert", "value"]);

  return (0, _jsxRuntime.jsx)(_LinearProgress["default"], _objectSpread({
    css: css.linear(invert),
    value: value
  }, props));
};

exports.Linear = Linear;

var Circular = function Circular(_ref2) {
  var _ref2$color = _ref2.color,
      color = _ref2$color === void 0 ? 'primary' : _ref2$color,
      _ref2$value = _ref2.value,
      value = _ref2$value === void 0 ? 0 : _ref2$value,
      _ref2$disabled = _ref2.disabled,
      disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
      props = _objectWithoutProperties(_ref2, ["color", "value", "disabled"]);

  return (0, _jsxRuntime.jsx)(_Box["default"], {
    position: "relative",
    display: "inline-flex",
    children: (0, _jsxRuntime.jsxs)("div", {
      css: css.circularRoot,
      children: [(0, _jsxRuntime.jsx)(_CircularProgress["default"], _objectSpread({
        variant: "determinate",
        css: css.circularBottom,
        thickness: 2.8,
        size: 16,
        value: 100
      }, props)), !disabled && (0, _jsxRuntime.jsx)(_CircularProgress["default"], _objectSpread({
        variant: "determinate",
        css: css.circularTop,
        color: color,
        thickness: 2.8,
        size: 16,
        value: value
      }, props)), (0, _jsxRuntime.jsx)(_Box["default"], {
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        position: "absolute",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        children: (0, _jsxRuntime.jsxs)(_Typography["default"], {
          variant: "caption",
          component: "div",
          css: css.circularTypography,
          children: [!disabled && value >= 100 && (0, _jsxRuntime.jsx)(_SvgIcon["default"], {
            fontSize: "small",
            component: _Done["default"],
            css: css.circularTick,
            color: color
          }), disabled && (0, _jsxRuntime.jsx)(_SvgIcon["default"], {
            fontSize: "small",
            component: _Clear["default"],
            css: css.circularCross
          })]
        })
      })]
    })
  });
};

exports.Circular = Circular;

var Bar = function Bar(_ref3) {
  var _ref3$currentStep = _ref3.currentStep,
      currentStep = _ref3$currentStep === void 0 ? 1 : _ref3$currentStep,
      _ref3$totalSteps = _ref3.totalSteps,
      totalSteps = _ref3$totalSteps === void 0 ? 1 : _ref3$totalSteps;
  return (0, _jsxRuntime.jsxs)("div", {
    css: css.barContainer,
    children: [(0, _jsxRuntime.jsx)("div", {
      css: css.bar,
      children: Array(totalSteps).fill('value').map(function (step, i) {
        return (// eslint-disable-next-line react/no-array-index-key
          (0, _jsxRuntime.jsx)("div", {
            css: css.barSection(totalSteps, i < currentStep)
          }, i)
        );
      })
    }), (0, _jsxRuntime.jsxs)("div", {
      css: css.barText,
      children: [currentStep, " of ", totalSteps]
    })]
  });
};

exports.Bar = Bar;